import { AppState, AppStateActionParams } from 'records/AppState';
import { UserProfile } from 'records/UserProfile';
import { createUserProfile } from 'services/userProfileService';

export interface UserProfileActions {
  createUserProfile: (
    actionParams: AppStateActionParams,
    userProfile: UserProfile
  ) => Promise<AppState>;
}

const userProfileActions = {
  createUserProfile: async (
    { state, actions }: AppStateActionParams,
    userProfile: UserProfile
  ): Promise<AppState> => {
    const { selectedProject } = state();
    const userid = await createUserProfile(selectedProject, userProfile);

    if (userid.length > 0) {
      await actions.getUsers();
    }

    return state();
  },
};

export default userProfileActions;
